import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/common";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { format, parseISO } from "date-fns";

export default function Audit() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/audit").then(({ data }) => setRows(data)); }, []);
  return (
    <>
      <PageHeader eyebrow="Compliance" title="Audit Log" subtitle="Every significant system event, immutable" />
      <div className="p-8">
        <div className="border border-border">
          <Table>
            <TableHeader>
              <TableRow className="border-border hover:bg-transparent">
                <TableHead className="label-mono">Timestamp</TableHead>
                <TableHead className="label-mono">Actor</TableHead>
                <TableHead className="label-mono">Action</TableHead>
                <TableHead className="label-mono">Resource</TableHead>
                <TableHead className="label-mono">Details</TableHead>
                <TableHead className="label-mono">IP</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {rows.map(r => (
                <TableRow key={r.id} className="border-border" data-testid={`audit-row-${r.id}`}>
                  <TableCell className="font-mono-brand text-xs">{format(parseISO(r.timestamp), "yyyy-MM-dd HH:mm:ss")}</TableCell>
                  <TableCell>
                    <div>{r.actor_name || "—"}</div>
                    <div className="text-xs text-muted-foreground font-mono-brand">{r.actor_employee_id || r.user_id}</div>
                  </TableCell>
                  <TableCell className="label-mono">{r.action}</TableCell>
                  <TableCell>{r.resource}</TableCell>
                  <TableCell className="text-xs font-mono-brand text-muted-foreground max-w-md truncate">{JSON.stringify(r.details)}</TableCell>
                  <TableCell className="text-xs font-mono-brand">{r.ip_address || "—"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </>
  );
}
